/**
 * Stable CSS class names for E2E — StoreCustomerService page and its drawers.
 * Containers use `store-customer-service__<element>`; inputs and
 * user-interactable controls use `store-customer-service-input--<name>`.
 */
export const SCS = {
    page: 'store-customer-service-page',
    root: 'store-customer-service',

    breadcrumb: 'store-customer-service__breadcrumb',

    /* --- Results state (after a successful search) ----------------------- */
    results: 'store-customer-service__results',
    resultsHeader: 'store-customer-service__results-header',
    resultsTitleBox: 'store-customer-service__results-title-box',
    resultsTitle: 'store-customer-service__results-title',

    detailDrawer: 'store-customer-service__detail-drawer',
    decisionDrawer: 'store-customer-service__decision-drawer',

    grid: 'store-customer-service__grid',

    /* --- Cells ----------------------------------------------------------- */
    cellStoreCode: 'store-customer-service__cell-store-code',
    cellStoreCodeText: 'store-customer-service__cell-store-code-text',
    cellStoreName: 'store-customer-service__cell-store-name',
    cellReturnId: 'store-customer-service__cell-return-id',
    cellDate: 'store-customer-service__cell-date',
    cellCustomerName: 'store-customer-service__cell-customer-name',
    cellPhone: 'store-customer-service__cell-phone',
    cellComplaint: 'store-customer-service__cell-complaint',
    cellComplaintText: 'store-customer-service__cell-complaint-text',
    cellCustomerNo: 'store-customer-service__cell-customer-no',

    cellActions: 'store-customer-service__cell-actions',
    btnRowMenu: 'store-customer-service-input--button-row-menu',
    rowMenu: 'store-customer-service__row-menu',
    rowMenuItem: 'store-customer-service__row-menu-item',
    rowMenuItemDetail: 'store-customer-service__row-menu-item--detail',
    rowMenuItemDecision: 'store-customer-service__row-menu-item--decision',

    /* --- Empty / search state ------------------------------------------- */
    emptyState: 'store-customer-service__empty-state',
    emptyNoRecord: 'store-customer-service__empty-no-record',
    filterForm: 'store-customer-service__filter-form',
    filterFormBody: 'store-customer-service__filter-form-body',

    filterType: 'store-customer-service__filter-type',
    inputType: 'store-customer-service-input--filter-type',
    typeMenuItem: 'store-customer-service__type-menu-item',
    typeMenuItemStore: 'store-customer-service__type-menu-item--store',
    typeMenuItemPhone: 'store-customer-service__type-menu-item--phone',

    filterStore: 'store-customer-service__filter-store',
    inputStore: 'store-customer-service-input--store',
    storeOption: 'store-customer-service__store-option',

    filterReturnId: 'store-customer-service__filter-return-id',
    inputReturnId: 'store-customer-service-input--return-id',

    filterPhone: 'store-customer-service__filter-phone',
    inputPhone: 'store-customer-service-input--phone',

    filterAction: 'store-customer-service__filter-action',
    btnFilter: 'store-customer-service-input--button-filter',

    /* --- Detail drawer content ------------------------------------------ */
    detail: 'store-customer-service__detail',
    detailHeader: 'store-customer-service__detail-header',
    detailItem: 'store-customer-service__detail-item',
    detailItemStoreCode: 'store-customer-service__detail-item--store-code',
    detailItemStoreName: 'store-customer-service__detail-item--store-name',
    detailItemReturnId: 'store-customer-service__detail-item--return-id',
    detailItemDate: 'store-customer-service__detail-item--date',
    detailItemComplaint: 'store-customer-service__detail-item--complaint',
    detailItemCustomerNo: 'store-customer-service__detail-item--customer-no',
    detailItemWarehouse: 'store-customer-service__detail-item--warehouse',
    detailItemFullName: 'store-customer-service__detail-item--full-name',
    detailItemPhone: 'store-customer-service__detail-item--phone',
    detailItemCounty: 'store-customer-service__detail-item--county',
    detailItemCity: 'store-customer-service__detail-item--city',
    detailItemStatus: 'store-customer-service__detail-item--status',

    /* --- Decision drawer content ---------------------------------------- */
    decision: 'store-customer-service__decision',
    decisionHeader: 'store-customer-service__decision-header',
    decisionCardWrapper: 'store-customer-service__decision-card-wrapper',
    decisionCard: 'store-customer-service__decision-card',
    decisionCardContent: 'store-customer-service__decision-card-content',
    decisionField: 'store-customer-service__decision-field',
    decisionFieldOzelKod: 'store-customer-service__decision-field--ozel-kod',
    decisionFieldBarkod: 'store-customer-service__decision-field--barkod',
    decisionFieldAd: 'store-customer-service__decision-field--ad',
    decisionFieldKarar: 'store-customer-service__decision-field--karar',
    decisionFieldKararGeri: 'store-customer-service__decision-field--karar-geri',
    decisionFieldKararOther: 'store-customer-service__decision-field--karar-other',
    decisionFieldKararVeren: 'store-customer-service__decision-field--karar-veren',
    decisionFieldKararTarih: 'store-customer-service__decision-field--karar-tarih',
    decisionFieldNeden: 'store-customer-service__decision-field--neden',
    decisionFieldSonucBilgi: 'store-customer-service__decision-field--sonuc-bilgi',
    decisionFieldGiderPusulaNo: 'store-customer-service__decision-field--gider-pusula-no',
    decisionFieldAciklama: 'store-customer-service__decision-field--aciklama',
    decisionFieldSonucYazisi: 'store-customer-service__decision-field--sonuc-yazisi',
} as const;

export const scsCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
